export const TRANSLATION_MANAGEMENT_FLAGS = {
    genTranslateLibraryAssets: {
        id: 'genTranslateLibraryAssets',
        value: false,
        description: 'Enables AI-generated translations for library assets.',
        owner: 'Translation Team',
        name: 'Translate with AI - Library Assets',
        extra: { section: 'Translation' },
    },
    genTranslateStudyAssets: {
        id: 'genTranslateStudyAssets',
        value: false,
        description: 'Enables AI-generated translations for study assets.',
        owner: 'Translation Team',
        name: 'Translate with AI - Study Assets',
        extra: { section: 'Translation' },
    },
    genTranslateTargetedStudyAssets: {
        id: 'genTranslateTargetedStudyAssets',
        value: false,
        description: 'Enables AI-generated translations for selected study assets only.',
        owner: 'Translation Team',
        name: 'Translate with AI - Study Assets (targeted only)',
        extra: { section: 'Translation' },
    },
};
